<ng-container *ngFor="let column of value.elements; let index = index">
  <div
    [ngStyle]="index | ipColumnStyles : value.options"
    cdkDropList
    [ipEmailBuilderColumn]="column"
  >
    <div
      class="relative group"
      cdkDrag
      *ngFor="let block of column; let i = index"
    >
      <div class="block" *ipEmailBuilderDynamicBlockDirective="block; let ins">
        <div class="menu-btn overflow absolute bottom-[-12px] opacity-0 block-hover transition-opacity p-1 shadow-lg transform -translate-x-2 rounded border-[1px] gap-2 flex custom-typography" >
          <button class="tool-button text-red-700/75" (click)="toggleBlockMenu(ins)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <circle cx="4" cy="12" r="2" />
              <circle cx="12" cy="12" r="2" />
              <circle cx="20" cy="12" r="2" />
            </svg>
          </button>
        </div>
        <div
          *ngIf="ins.id == activeBlockId"
          class="overflow absolute bottom-[-12px] opacity-1 transition-opacity tooltip p-1 shadow-lg transform -translate-x-2 rounded border-[1px] gap-2 flex custom-typography"
        >
          <ng-container *ngIf="ins.type === 'text'">
            <button
              #textButton
              hidden
              (click)="ins.edit(); edited(ins)"
            ></button>
          </ng-container>
          <button
            class="tool-button"
            (click)="ins.edit()"
            *ngIf="ins | ipCan : 'edit'"
          >
            <svg
              class="h-3 w-3 dark:text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
              ></path>
            </svg>
          </button>
          <button
            class="tool-button"
            (click)="duplicateBlock($event, ins, column)"
            *ngIf="ins | ipCan : 'duplicate'"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"
              />
              <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
            </svg>
          </button>
          <button class="tool-button cursor-move" cdkDragHandle>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          <button
            class="tool-button text-red-700/75"
            (click)="removeBlock($event, ins, column, i)"
            *ngIf="ins | ipCan : 'delete'"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          <ng-container
            *ngIf="
              ins.type === 'text' ||
              ins.type === 'button' ||
              ins.type === 'html'
            "
          >
            <button
              class="tool-button text-green-700/75"
              (click)="paste($event, ins)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 
             2 0 002 2h14a2 2 0 002-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1h-2c0-.55.45-1 1-1zm5 
             16H7V7h10v12z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div
  class="absolute top-0 right-0 opacity-0 group-hover:opacity-100 group-hover:z-20 transition-opacity bg-white p-1 shadow-lg rounded border-[1px] gap-2 flex"
>
  <button class="tool-button" (click)="edit()" *ngIf="value | ipCan : 'edit'">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-3 w-3"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
      />
    </svg>
  </button>
  <button class="tool-button cursor-move" cdkDragHandle>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-3 w-3"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fill-rule="evenodd"
        d="M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z"
        clip-rule="evenodd"
      />
    </svg>
  </button>
</div>

<ng-container
  *ipEmailBuilderSettings
  [ipEmailBuilderHistoryHost]="this | toHistoryOptions"
>
  <h2 tailH2 i18n="@@structure_actions">Actions</h2>
  <div class="flex gap-1">
    <button
      class="text-black/75"
      tailBtn
      ipTooltip="Duplicate"
      i18n-ipTooltip="@@structure_duplicate"
      (click)="duplicateSelf()"
      *ngIf="value | ipCan : 'duplicate'"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"
        />
        <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
      </svg>
    </button>
    <button
      class="text-red-700/75"
      tailBtn
      ipTooltip="Delete"
      i18n-ipTooltip="@@structure_delete"
      (click)="removeSelf()"
      *ngIf="value | ipCan : 'delete'"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <button
      class="text-green-700/75"
      tailBtn
      ipTooltip="Save as new module"
      i18n-ipTooltip="@@structure_save_as_module"
      *ngIf="value | ipCan : 'save'"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          d="M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z"
        />
      </svg>
    </button>
  </div>
  <h2 tailH2 i18n="@@background">Background</h2>
  <tail-background
    tailPanel
    [(value)]="value.options.background"
  ></tail-background>
  <h2 tailH2 i18n="@@border">Border</h2>
  <tail-border tailPanel [(value)]="value.options.border"></tail-border>
  <h2 tailH2 i18n="@@padding">Padding</h2>
  <tail-padding tailPanel [(value)]="value.options.padding"></tail-padding>
  <h2 tailH2 i18n="@@margin">Margin</h2>
  <tail-margin tailPanel [(value)]="value.options.margin"></tail-margin>
  <h2 tailH2 i18n="@@layout">Layout</h2>
  <div tailPanel>
    <div class="grid grid-cols-2 gap-2">
      <div class="flex flex-col">
        <label [tailLabel]="vertical" i18n="@@structure_vertical_gap"
          >Vertical Gap</label
        >
        <input
          tailInput
          #vertical="input"
          type="number"
          [(ngModel)]="value.options.gaps[0]"
        />
      </div>
      <div class="flex flex-col">
        <label [tailLabel]="horizontal" i18n="@@structure_horizontal_gap"
          >Horizontal Gap</label
        >
        <input
          tailInput
          #horizontal="input"
          type="number"
          [(ngModel)]="value.options.gaps[1]"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-2 pt-2">
      <button
        tailBtn
        [class.active]="value.options.disableResponsive"
        (click)="
          value.options.disableResponsive = !value.options.disableResponsive
        "
        i18n="@@disable_responsive"
      >
        Disable responsive
      </button>
      <button
        tailBtn
        [class.active]="value.options.fullWidth"
        (click)="value.options.fullWidth = !value.options.fullWidth"
        i18n="@@full_width_structure"
      >
        Full width structure
      </button>
    </div>
  </div>

  <h2 tailH2 i18n="@@structure_columns_styles">Columns styles</h2>
  <div tailPanel>
    <div class="grid grid-cols-6 gap-2">
      <button
        *ngFor="let index of columnsSize"
        tailBtn
        (click)="editColumn(index)"
        [class.active]="editColumnIndex === index"
      >
        {{ index + 1 }}
      </button>
    </div>

    <ng-container
      *ngFor="let column of value.options.columns; let index = index"
    >
      <div class="flex flex-col pt-2" *ngIf="editColumnIndex === index">
        <h3 tailH3 i18n="@@background_color">Background Color</h3>
        <tail-color [(value)]="column.background.color"></tail-color>
        <h3 tailH3 class="pt-1" i18n="@@border">Border</h3>
        <tail-border [(value)]="column.border!"></tail-border>
        <h3 tailH3 class="pt-1" i18n="@@vertical_align">Vertical Align</h3>
        <div class="grid grid-cols-3 gap-2">
          <button
            tailBtn
            *ngFor="let align of verticalLabels"
            [class.active]="column.verticalAlign === align"
            (click)="column.verticalAlign = align"
          >
            {{ getVerticalAlignLabel(align) }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
